import moment from 'moment';

const state = {
    productType:'',
    product:null,
};

const getters = {
    product: state => state.product,
    productType: state => state.productType,
    inactiveDates: state => {

        if(!state.product.inactive_dates){
            let now = moment();
            const endDate = moment().add(2, 'y');
            let dates = [];

            while(now.isSameOrBefore(endDate)){
                if (now.isoWeekday() === 1){
                    dates.push(now.format('YYYY-MM-DD'));
                }
                now.add(1,'days');
            }
            return dates;
        }

        let daysFromBackend = state.product.inactive_dates.map(item => {
            return moment(item.inactive_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        });
        
        const today = moment();
        const endDate = moment().add(2, 'y');

        let now = today.clone();
        let dates = [];

        while(now.isSameOrBefore(endDate)){
            if (now.isoWeekday() === 1){
                dates.push(now.format('YYYY-MM-DD'));
            }
            now.add(1,'days');
        }

        return dates.concat(daysFromBackend);
    },
};

const actions = {
    getProduct({commit, state}, slug){
        axios.get(`/api/public/product/${slug}`).then((response) => {
            commit('setProduct', response.data.data);
        })
    },
    setProductType({commit, state}, productType){
        commit('setStoreProductType', productType);
    }
};

const mutations = {
    setProduct(state, product){
        state.product = product;
    },
    setStoreProductType(state, productType){
        state.productType = productType;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
